import React from 'react';
import Section from '../../components/Section';
import ServicesDetails from '../../components/ServicesDetails';
import AccordionSection from '../../components/AccordionSection';
import CallToAction from '../../components/CallToAction';
import Contact from '../../components/Contact';
import { useTranslation } from 'react-i18next';

function Services() {
  const { t } = useTranslation();

  return (
    <>
      {/* Compensation de la navbar */}
      <div className="pt-28"> 
        {/* Section d’introduction */}
        <Section
          sectionTitle={t('PageServices.sectionTitle')}
          title={t('PageServices.title')}
          spanTitle={t('PageServices.spanTitle')}
          description={t('PageServices.description')}
          image="/images/cloud.png"
        />

        {/* Grille des services */}
        <div className="bg-gray-50 dark:bg-slate-950 py-10">
          <div className="text-center px-6 lg:px-20 w-full mb-12">
            <h6 className="text-xl font-bold text-blue-600 mb-4">
              {t('PageServices.servicesSpan')}
            </h6>
            <h1 className="text-4xl font-bold text-gray-800 dark:text-gray-200 mb-4">
              {t('PageServices.servicesTitle')}{' '}
              <span className="text-blue-600">{t('PageServices.servicesSpan')}</span>
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              {t('PageServices.description')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-10">
            <ServicesDetails
              id="WebDevelopment"
              title={t('PageServices.webDevelopment.title')}
              subtitle={t('PageServices.webDevelopment.subtitle')}
              icon={<img src="/images/developpers.png" alt="Web Dev Icon" width={50} />}
              description={t('PageServices.webDevelopment.description')}
              features={t('PageServices.webDevelopment.features', { returnObjects: true })}
              image="/images/web.png"
            />

            <ServicesDetails
              id="DigitalMarketing"
              title={t('PageServices.digitalMarketing.title')}
              subtitle={t('PageServices.digitalMarketing.subtitle')}
              icon={<img src="/images/marketing1.png" alt="Marketing Icon" width={50} />}
              description={t('PageServices.digitalMarketing.description')}
              features={t('PageServices.digitalMarketing.features', { returnObjects: true })}
              image="/images/marketing.png"
            />

            <ServicesDetails
              id="seoServices"
              title={t('PageServices.seoServices.title')}
              subtitle={t('PageServices.seoServices.subtitle')}
              icon={<img src="/images/search.png" alt="SEO Icon" width={50} />}
              description={t('PageServices.seoServices.description')}
              features={t('PageServices.seoServices.features', { returnObjects: true })}
              image="/images/seo.png"
            />

            <ServicesDetails
              id="graphicDesign"
              title={t('PageServices.graphicDesign.title')}
              subtitle={t('PageServices.graphicDesign.subtitle')}
              icon={<img src="/images/design.png" alt="Design Icon" width={50} />}
              description={t('PageServices.graphicDesign.description')}
              features={t('PageServices.graphicDesign.features', { returnObjects: true })}
              image="/images/design.png"
            />

            <ServicesDetails
              id="mobileDevelopment"
              title={t('PageServices.mobileDevelopment.title')}
              subtitle={t('PageServices.mobileDevelopment.subtitle')}
              icon={<img src="/images/mobile1.png" alt="Mobile Icon" width={50} />}
              description={t('PageServices.mobileDevelopment.description')}
              features={t('PageServices.mobileDevelopment.features', { returnObjects: true })}
              image="/images/mobile.png"
            />
          </div>
        </div>

        {/* Appel à l'action */}
        <CallToAction
          title={t('PageServices.cta.title')}
          description={t('PageServices.cta.description')}
        />

        {/* Processus de travail + Contact */}
        <AccordionSection />
        <Contact />
      </div>
    </>
  );
}

export default Services;
